import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointOnly,
  getBreakpointUp,
  getFontCss,
  styleConstants,
  Tag,
  TagScales,
  TagSizes,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import NavAwayBox from 'src/components/NavAwayBox/NavAwayBox'
import SvgOrganizationFilled from 'src/components/Svgs/SvgOrganizationFilled'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import Trns from 'src/localization/Trns'
import { UserListModel } from 'src/models/user.models'
import { peopleMembersDetailUrl, profileInfoUrl } from 'src/navigation/urls'
import { css } from 'styled-components'

interface ProfileSummaryBoxProps {
  user: UserListModel
}

const ProfileSummaryBox: React.FC<ProfileSummaryBoxProps> = (
  props,
): React.ReactElement => {
  return (
    <NavAwayBox
      navAway={{
        to: profileInfoUrl(),
        label: <Trns source={'Personal Info'} />,
        ariaLabelSource: 'Personal Info',
      }}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          padding: 36px 40px;

          ${getBreakpointOnly(breakpointSizes.XXSM)(css`
            padding: 36px 20px;
          `)}
        `}
      >
        <UserAvatar size={AvatarSizes.ExtraHuge} user={props.user} />
        <div
          css={css`
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            width: fit-content;
          `}
        >
          <span
            css={css`
              ${getFontCss(
                20,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
            `}
          >
            <span
              css={css`
                display: flex;
                flex-direction: row;
                align-items: center;
              `}
            >
              <span
                css={css`
                  margin-right: 8px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                `}
              >
                {props.user.truncatedFullNameOrEmail}
              </span>
              <span
                css={css`
                  ${getBreakpointDown(breakpointSizes.XXSM)(css`
                    display: none;
                  `)}
                `}
              >
                {!!props.user.orgRoleDisplayTagTitle && (
                  <Tag
                    text={<Trns source={props.user.orgRoleDisplayTagTitle} />}
                    size={TagSizes.Large}
                    icon={
                      props.user.hasOrgOwnerPermissions ? (
                        <SvgOrganizationFilled style={TagScales.large} />
                      ) : undefined
                    }
                  />
                )}
              </span>
            </span>
          </span>
          {props.user.hasFullName && (
            <HoverableLink
              css={css`
                margin-top: 4px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              `}
              to={peopleMembersDetailUrl(props.user.id)}
              underline
              ariaLabel={props.user.email}
            >
              {props.user.email}
            </HoverableLink>
          )}
          <span
            css={css`
              margin-top: 8px;
              ${getBreakpointUp(breakpointSizes.XSM)(css`
                display: none;
              `)}
            `}
          >
            {!!props.user.orgRoleDisplayTagTitle && (
              <Tag
                text={<Trns source={props.user.orgRoleDisplayTagTitle} />}
                size={TagSizes.Medium}
                icon={
                  props.user.hasOrgOwnerPermissions ? (
                    <SvgOrganizationFilled style={TagScales.medium} />
                  ) : undefined
                }
              />
            )}
          </span>
        </div>
      </div>
    </NavAwayBox>
  )
}

export default ProfileSummaryBox
